import { AlertColor } from "@mui/material"
import { createSlice } from "@reduxjs/toolkit"

export interface Options {
  autoHideDuration: number
  severity: AlertColor
}

const defaultOptions = {
  autoHideDuration: 10000,
  severity: "info" as AlertColor,
}

const initialState: {
  open: boolean
  message: string | null
  options: Options
} = {
  open: false,
  message: null,
  options: defaultOptions,
}

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast(state, action) {
      state.open = true
      state.message = action.payload.message
      state.options = action.payload.options
        ? { ...defaultOptions, ...action.payload.options }
        : defaultOptions
    },
    closeToast(state) {
      state.open = false
    },
  },
})

export const { showToast, closeToast } = toastSlice.actions

export default toastSlice.reducer
